import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import './../NewUser.scss';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import {useHistory} from 'react-router-dom';
import actions from '../../../../redux/actions';
import * as yup from 'yup';
import _ from 'lodash';
import Loading from '../../../../common/components/Loading/Loading';
import CustomAlert from '../../../../common/components/Alert/CustomAlert';
import {deleteExtraSpaces} from '../../../../utils/util';
import CustomInput from '../../../../common/components/CustomInput/CustomInput';
import CustomSelect from '../../../../common/components/CustomSelect/CustomSelect';
import Button from '../../../../common/components/Button/Button';
import ArrowBackComponent from '../../../../common/components/ArrowBack/ArrowBack';
import {CustomPhone} from '../../../../common/components/CustomPhone/CustomPhone';
import {FormControlLabel, Radio, RadioGroup, Switch} from '@mui/material';
import InfoTooltip from '../../../../common/components/InfoTooltip/InfoTooltip';
import {VER_MONTOS_TOOLTIP} from '../../../../pages/ProviderUsers/permissionTooltips';

export const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const NewUser = (props) => {
    const {
        userInfo,
        getBranches,
        getBranchesProviders,
        branches,
        branchesProviders,
        setProviderSelected,
        addProvider,
        newProviderState,
        cleanNewProviderState,
        getBranchesState,
        getBranchesProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        showSidebar,
    } = props;
    const validationSchema =
        yup.object({
            name: yup
                .string('Ingrese nombre')
                .required('Ingrese nombre'),
            cuitOrCuil: yup
                .string('Ingrese cuit')
                .matches(/^[0-9]{2}-[0-9]{8}-[0-9]$/, 'Cuit Inválido')
                .required('Ingrese cuit'),
            email: yup
                .string('Ingrese email')
                .email('Email inválido')
                .required('Ingrese email'),
            salesforceProviderId: yup
                .string('Seleccione un prestador')
                .required('Seleccione un prestador'),
            salesforceBranchId: yup.string().when('type', {
                is: 'PROVIDER_USER',
                then: yup.string('Seleccione una sede')
                    .required('Seleccione una sede'),
                otherwise: yup.string(),
            }),
            phoneNumbers: yup.array().of(
                yup.object().shape({
                    type: yup
                        .string('Ingrese tipo')
                        .required('Ingrese tipo'),
                    number: yup.string().when('type', {
                        is: 'OTHER',
                        then: yup.string('Ingrese número')
                            .required('Ingrese número'),
                        otherwise: yup.string('Ingrese número')
                            .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                                'Número Inválido (No olvide colocar el código de área)')
                            .required('Ingrese número')}),
                }),
            )
                .required('Teléfonos requeridos'),
            permission: yup.string().optional(),
        });
    const history = useHistory();
    const formik = useFormik({
        initialValues: {
            type: 'PROVIDER_USER',
            name: '',
            cuitOrCuil: '',
            email: '',
            salesforceProviderId: userInfo?.salesforceProviderId || '',
            salesforceBranchId: userInfo?.salesforceBranchId || '',
            phoneNumbers: [{type: 'PERSONAL', number: ''}],
            permission: 'ALL',
            verMontoValidador: true,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log(values);
            const user = values.type === 'PROVIDER_USER' ?
                _.omit(values, ['type', 'permission']) :
                _.omit(values, ['type', 'salesforceBranchId', 'permission', 'verMontoValidador']);
            const typeByRole = {
                'PROVIDER_USER': 'user',
                'PROVIDER_ADMIN': 'admin',
                'DEVELOPER': 'developer',
            };
            const body = {
                type: typeByRole[values.type],
                user: {...user, permissions: [values.permission]},
            };
            setProviderSelected(values);
            addProvider(body);
        },
    });

    useEffect(
        () => {
            if ( newProviderState.success ) {
                cleanNewProviderState();
                history.goBack();
            };
        }, [newProviderState],
    );

    useEffect(()=>{
        cleanBranches();
        cleanProvidersBranches();
        getBranches();
    }, []);

    useEffect(()=>{
        formik.resetForm({values: {...formik.values, salesforceBranchId: ''}});
        if (formik.values.type==='PROVIDER_USER' && formik.values.salesforceProviderId) {
            getBranchesProviders(formik.values.salesforceProviderId);
        }
    }, [formik.values.salesforceProviderId]);

    useEffect(()=> {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            const result = {value: branch.providerId.toString(), label: deleteExtraSpaces(branch.fullName)};
            return result;
        }));
    }, [branches, getBranchesState.success]);

    useEffect(()=> {
        branchesProvidersOptions.current = branchesProviders?.map((branch) => {
            return {value: branch.branchId.toString(), label: deleteExtraSpaces(branch.fullName)};
        });
        formik.setFieldValue('salesforceBranchId', branchesProvidersOptions?.current[0]?.value);
    }, [branchesProviders, getBranchesProvidersState.success]);

    const [branchesOptions, setBranchesOptions] = useState([]);
    const branchesProvidersOptions = useRef([]);

    const handleArrowBack = () => {
        history.goBack();
    };

    return ( getBranchesState.success ?
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}
             style={{backgroundColor: 'transparent', margin: '10px', padding: '10px', paddingRight: '40px'}}>
            <div className="ul-div-sect-header">
                <div style={{display: 'flex'}}>
                    <div style={{width: '40px', height: '40px', marginRight: '20px'}}>
                        <ArrowBackComponent onClick={handleArrowBack} />
                    </div>
                    <p className="h3 v2-c-text-title">Nuevo Usuario de Prestador</p>
                </div>
                <div className="eu-radio-container" style={{marginLeft: '20px'}}>
                    <input
                        type='radio'
                        value={'PROVIDER_ADMIN'}
                        onChange={formik.handleChange}
                        name='type'
                        className="eu-radio"
                        checked={formik.values.type==='PROVIDER_ADMIN'}
                    />
                    Admin de prestador
                    <input
                        type='radio'
                        value={'PROVIDER_USER'}
                        onChange={formik.handleChange}
                        name='type'
                        className="eu-radio"
                        checked={formik.values.type==='PROVIDER_USER'}
                    /> Usuario de sede
                    <input
                        type='radio'
                        value={'DEVELOPER'}
                        onChange={formik.handleChange}
                        name='type'
                        className="eu-radio"
                        checked={formik.values.type==='DEVELOPER'}
                    /> Desarrollador
                </div>
            </div>

            <div className="ul-div-form">

                <form className="eu-form" onSubmit={formik.handleSubmit}>
                    <input type="hidden" name="password" value={formik.values.password} onChange={formik.handleChange} />
                    <input type="hidden" name="zipCode" value={formik.values.zipCode} onChange={formik.handleChange} />
                    <div className="eu-div-container">
                        <div className="eu-div-input">
                            <CustomInput
                                label="Nombre"
                                placeholder="Nombre"
                                onChange={(value)=> {
                                    formik.setFieldValue('name', value);
                                }}
                                value={formik.values.name}
                                type={'text'}
                            />
                            <CustomInput
                                label="Cuit/Cuil"
                                placeholder="Cuit/Cuil"
                                onChange={(value)=> {
                                    formik.setFieldValue('cuitOrCuil', value);
                                }}
                                value={formik.values.cuitOrCuil}
                                type={'cuit'}
                            />
                        </div>
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='name' className='eu-input-l' />
                            <InputErrorMessage formik={formik} name='cuitOrCuil' className='eu-input-s' />
                        </div>
                        <div className="eu-div-input">
                            <CustomInput
                                label="Email"
                                placeholder="Email"
                                onChange={(value)=>formik.setFieldValue('email', value)}
                                value={formik.values.email}
                                type={'text'}
                            />
                            <CustomSelect
                                label={'Prestador'}
                                placeholder={'Prestador'}
                                onChange={(value)=> {
                                    formik.setFieldValue('salesforceProviderId', value);
                                }}
                                options={branchesOptions}
                                value={formik.values.salesforceProviderId}
                                isSearchable={true}
                            />
                        </div>
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='email' className='eu-input-l' />
                            <InputErrorMessage formik={formik} name='salesforceProviderId' className='eu-input-s' />
                        </div>
                        {formik.values.type==='PROVIDER_USER' &&
                            <>
                                <div className="eu-div-input">
                                    <CustomSelect
                                        label={'Sede'}
                                        placeholder={'Sede'}
                                        onChange={(value)=> {
                                            formik.setFieldValue('salesforceBranchId', value);
                                        }}
                                        options={branchesProvidersOptions.current}
                                        value={formik.values.salesforceBranchId}
                                        isSearchable={true}
                                    />
                                </div>
                                <div className="eu-div-input">
                                    <InputErrorMessage formik={formik} name='salesforceBranchId' className='eu-input-l' />
                                </div>
                            </>
                        }
                        <CustomPhone formik={formik} />
                        {formik.values.type === 'PROVIDER_USER' &&
                            <div className="eu-div-input">
                                <div className="v2-input-div">
                                    <p className='body-3 c-text-subtitle'>Permisos</p>
                                    <RadioGroup
                                        onChange={(e) => formik.setFieldValue('permission', e.target.value)}
                                        value={formik.values.permission}
                                        name='permissions'>
                                        <FormControlLabel value="ALL" control={<Radio />} label="Todos los permisos" />
                                        <FormControlLabel value="QUOTE" control={<Radio />} label="Consultar coberturas y cotizaciones" />
                                        <FormControlLabel value="VIEW_AFFILIATES" control={<Radio />} label="Consultar coberturas" />
                                    </RadioGroup>
                                </div>
                                <div className="v2-input-div">
                                    <p className='body-3 c-text-subtitle' style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                                        Puede ver montos
                                        <InfoTooltip title={VER_MONTOS_TOOLTIP}/>
                                    </p>
                                    <Switch
                                        checked={formik.values.verMontoValidador}
                                        onChange={(e) => formik.setFieldValue('verMontoValidador', e.target.checked)}
                                    />
                                </div>
                            </div>
                        }
                        <div className="eu-div-button">
                            <Button type="submit" size="medium">Crear</Button>
                        </div>
                    </div>

                </form>
            </div>
        </div> :
        getBranchesState.loading ? <Loading className="ul-div-sect-table"/> :
            <CustomAlert text={'planes' || String(getBranchesState.error)} severity='error'/>);
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    users: state.home.users,
    userInfo: state.login.userInfo,
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    newProviderState: state.home.newProviderState,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    addProvider: (provider) => dispatch(actions.home.addProviderRequest(provider)),
    cleanNewProviderState: () => dispatch(actions.home.cleanNewProviderState()),
    cleanGetBranchesState: () => dispatch(actions.home.cleanGetBranchesState()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
});

NewUser.propTypes = {
    name: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);
